import axios from "axios";
import {SERVERS_HOST_LIST} from "@/config";

const baseUrl = function () {
    if (localStorage['region'] === 'RU') {
        return SERVERS_HOST_LIST[0]
    } else if (localStorage['region'] === 'EU') {
        return SERVERS_HOST_LIST[1]
    } else {
        return SERVERS_HOST_LIST[0]
    }
}


async function DeviceId() {
    if (localStorage['device-uid']) {
        return localStorage.getItem('device-uid')
    }
    let response: string
    try {
        const {data} = await axios.get(baseUrl() + 'v1/auth/get-uid')
        response = data.uid
        localStorage.setItem('device-uid', response)
    } catch (e) {
        response = 'error'
    }
    return response
}


const defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}

const apiAxios = axios.create({
    baseURL: baseUrl(),
    headers: defaultHeaders,
})


export {apiAxios, baseUrl, DeviceId}